import { render } from "./NavMenuDesktop.vue?vue&type=template&id=4edf4c90&ts=true"
import script from "./NavMenuDesktop.vue?vue&type=script&lang=ts"
export * from "./NavMenuDesktop.vue?vue&type=script&lang=ts"

import "./NavMenuDesktop.vue?vue&type=style&index=0&id=4edf4c90&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__